module.exports = __webpack_public_path__ + "media/components/src/assets/images/twitter-8e7232cc5e5c0426a547a1012fa8fda0.svg";